<template>
	<div class="goods-list">
		<div class="goods-tab">
			<div @click="changeTab(0)" :class="['goods-tab-item',active==0 ? 'active' : '']">
				<span>销量</span>
				<i class="iconfont iconshangxiajiantou"></i>
			</div>
			<div @click="changeTab(1)" :class="['goods-tab-item',active==1 ? 'active' : '']">
				<span>价格</span>
				<i class="iconfont iconshangxiajiantou"></i>
			</div>
			<div @click="changeTab(2)" :class="['goods-tab-item',active==2 ? 'active' : '']">
				<i class="iconfont iconziyuan"></i>
			</div>
		</div>
		<input type="text" v-show="active==2" class="search" placeholder="输入商品id/关键字,按回车搜索" v-model="search_str" @keyup.enter="search">
		<ul class="goods-ul" style="overflow:auto" v-infinite-scroll="getGoosList" infinite-scroll-disabled="false">
			<div class="goods-item" v-for="(item,idnex) in goodsList">
				<div class="item-left">
					<img class="goods-img" :src="item.default_image">
				</div>
				<div class="item-right">
					<div class="item-row goods-name text-ellipsis">
						{{item.goods_name}}
					</div>
					<div class="item-row">
						<span class="goods-stock">库存:{{item.stock}}</span>
						<span class="goods-sale">销量:{{item.orders}}</span>
					</div>
					<div class="item-row goods-price">
						价格:￥{{item.price}}
					</div>
					<div class="item-row item-btn">
						<el-popover placement="bottom" width="230" trigger="click">
							<div class="item-sku">
								<div class="item-sku-row" v-for="(el,index) in item.goods_sku" :key="index">
									<span class="sku-name">{{el.spec_1}}</span>
									<span class="sku-price">{{el.price}}</span>
									<span class="sku-stock">{{el.stock}}件</span>
								</div>
							</div>
							<a slot="reference" class="item-row-btn">SKU</a>
						</el-popover>

						<a class="item-row-btn" @click="sendCheckOrder(item.goods_id,item.goods_name,item.default_image,item.price)">发送</a>
					</div>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'GoodsList',
		data() {
			return {
				active: 0, //激活项 0销量 1价格 2搜索
				search_str: '', //搜索内容
				limit: 10,
				page: 0,
				goodsList: [],
				is_reverse: false, //是否倒序
				
			}
		},
		props: {
			store_id: Number,
			User_code:String,
			friend_id:Number,//聊天对象id 
			msgkey:String,
		},
		methods: {
			search() {
				this.is_reverse = true;
				this.page = 0;
				this.goodsList = [];
				this.getGoosList();
			},
			// 处理头像
			getAvitor(portrait) {
				var now_avitor;
				if (portrait == null || portrait == "null" || portrait == "") {
					now_avitor='../static/default_portrait.png'
				}else if (portrait != null || portrait != "null") {
					console.log()
					if (portrait.substr(0, 8).toLowerCase() == "https://" || portrait.substr(0, 7).toLowerCase() == "http://") {
						now_avitor = portrait;
					} else {
						now_avitor = this.URL + portrait;
					}
				}
				// console.log(now_avitor)
				return now_avitor;
			},
			changeTab(index) {
				this.active = index;
				console.log(index)
				switch (index) {
					case 0:
						console.log('销量排序');
						// this.page = 0;
						// this.getGoosList();
						if (this.is_reverse) {
							this.goodsList.sort(function(item1, item2) {
								return item2.orders - item1.orders;
							})
						} else {
							this.goodsList.sort(function(item1, item2) {
								return item1.orders - item2.orders;
							})
						}
						this.is_reverse = !this.is_reverse;
						break;
					case 1:
						console.log('价格排序');
						// this.page = 0;
						// this.getGoosList();
						if (this.is_reverse) {
							this.goodsList.sort(function(item1, item2) {
								return item2.price - item1.price;
							})
						} else {
							this.goodsList.sort(function(item1, item2) {
								return item1.price - item2.price;
							})
						}
						this.is_reverse = !this.is_reverse;
						break;
					case 2:
						console.log('显示搜索')
						break;
					default:
						break;
				}
			},
			//发送核对商品
			sendCheckOrder(goods_id,goods_name,default_image,price) {
				var goods="goods_id:"+goods_id+","+"goods_name:"+goods_name+","+"default_image:"+default_image+","+"price:"+price
				var bild = '{"type":"say","fromid":"' + this.User_code + '","toid":"' + this.friend_id +
					'","msgtype":"6","chat_type":"2","data":"' + goods + '","msgkey":"' + this.msgkey +
					'","loginType":"pc","onlineType":"pc","store_id":"' + this.store_id + '"}';
				console.log(bild)
				this.$http.send(bild)
			},
			async getGoosList() {
				var that = this
				// let param = new URLSearchParams()
				// param.append('store_id',this.store_id)
				// param.append('search_str', this.search_str)
				// param.append('limit', this.limit)
				// param.append('page', this.page)
				if (!this.store_id) {
					return
				}
				var res = await this.$axios.post('/checkOrder/lookStoreGood', {
					store_id: this.store_id,
					search_str: this.search_str,
					limit: this.limit,
					page: this.page
				})
				if (res.data.done) {
					this.goodsList = this.goodsList.concat(res.data.data);
					this.goodsList.forEach(function(item,index){
						item.default_image = that.getAvitor(item.default_image)
					})
					this.page++;
				} else {
					this.$message.error(res.data.msg)
				}
			},
		},
		created() {
			// this.getGoosList();
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.goods-list {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		border-left: 1px solid #eee;
	}

	.goods-tab {
		display: flex;
		width: 100%;
		height: 42px;
		box-sizing: border-box;
	}
	.goods-tab .iconfont{
		font-size: 12px;
		transform: translateY(2px);
		margin-left: 5px;
	}

	.search {
		margin: 22px;
		padding-left: 18px;
		width: calc(100% - 44px);
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #eee !important;
		outline: none;
	}

	.search:focus {
		border: 1px solid #4b73ec !important;
		outline: none;
	}

	.goods-ul {
		background-color: #fff;
		width: 100%;
		margin: 0;
		padding: 0;
		height: calc(100% - 42px);
	}

	.goods-tab-item {
		display: flex;
		height: 100%;
		background-color: #fff;
		border-left: 1px solid #eee;
		flex: 1;
		align-items: center;
		justify-content: center;
	}

	.active {
		background-color: #e0e7f1;
		color: #4b71ec;
	}

	.goods-item {
		margin: 28px 10px 0 10px;
		width: calc(100% - 20px);
		height: 100px;
		display: flex;
	}

	.item-left {
		width: 100px;
		height: 100px;
	}

	.item-left .goods-img {
		width: 100px;
		height: 100px;
	}

	.item-right {
		display: flex;
		width: calc(100% - 100px);
		box-sizing: border-box;
		height: 100px;
		flex-direction: column;
	}

	.item-right .item-row {
		padding-left: 18px;
		box-sizing: border-box;
		height: 25%;
	}

	.text-ellipsis {
		text-overflow: ellipsis;
		overflow: hidden;
		display: inline-block;
		white-space: nowrap;
		width: 100%;
	}

	.goods-name {
		font-size: 16px;
		color: #333333;
	}

	.goods-stock,
	.goods-sale {
		font-size: 12px;
		color: #888888;
		padding-right: 30px;
	}

	.goods-price {
		font-size: 16px;
		color: #f91329;
	}

	.item-btn {
		display: flex;
	}

	.item-row-btn {
		border: 1px solid #4b71ec;
		color: #5792fa;
		width: 70px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
		font-size: 14px;
	}
	.item-row-btn:active{
		background-color: #4b71ec;
		color: #fff;
	}
	.item-sku {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		justify-content: space-around;
	}

	.item-sku-row {
		display: flex;
		justify-content: space-around;
	}
</style>
